import React, { useEffect, createElement } from 'react';
import { ArticleHeader } from './components/ArticleHeader';
import { ArticleBody } from './components/ArticleBody';
import { MicroCommitment } from './components/MicroCommitment';
import { HowToStart } from './components/HowToStart';
import { StickyMobileCTA } from './components/StickyMobileCTA';
export function App() {
  useEffect(() => {
    // Install Meta Pixel
    const w = window as any;
    if (!w.fbq) {
      const n = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    w.fbq('init', '1225428543097695');
    w.fbq('track', 'PageView');
  }, []);
  // RTK Click ID tracking — appends sub2 param to all CTA links
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    let clickid = urlParams.get('rtkclickid');
    if (clickid) {
      localStorage.setItem('rtkclickid', clickid);
    }
    clickid = localStorage.getItem('rtkclickid');
    if (clickid) {
      document.querySelectorAll('a').forEach(function (el) {
        const url = 'https://www.apwkk8trk.com/94J6RZ/293Z4R/?sub2=' + clickid;
        el.setAttribute('href', url);
      });
    }
  }, []);
  return <div className="min-h-screen bg-white text-[#111111] selection:bg-[#FFFF00] selection:text-black font-sans pb-20 md:pb-0" data-id="element-0">
      <main className="max-w-[960px] mx-auto px-4 sm:px-6 py-8 md:py-12" data-id="element-1">
        <ArticleHeader data-id="element-2" />
        <ArticleBody data-id="element-3" />
        <MicroCommitment data-id="element-4" />
        <HowToStart data-id="element-5" />
      </main>
      <StickyMobileCTA data-id="element-6" />
    </div>;
}